import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2EncyclopediaIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 16.207 17.279",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 17.279),
    children: [/*#__PURE__*/jsx("path", {
      d: "m7.425 16.571h-5.327a1.6 1.6 0 0 1 -1.6-1.6"
    }), /*#__PURE__*/jsx("path", {
      d: "m13.369 5.86v-4.824a.536.536 0 0 0 -.536-.536h-10.188a2.145 2.145 0 0 0 -2.145 2.144v12.329a1.608 1.608 0 0 1 1.609-1.608h2.681"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.446 11.245a3.729 3.729 0 1 0 3.729-3.729 3.729 3.729 0 0 0 -3.729 3.729z"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.5 16.571-2.69-2.69"
    })]
  });
};

export { PM2EncyclopediaIcon };
//# sourceMappingURL=encyclopedia.js.map
